/**
 * Options for different types of carousels.
 */

const _default = {
    slidesPerView: "auto",
    grabCursor: true,
    passiveListeners: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
};

const largeCarousel = {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 0,
    // autoplay: {
    //     delay: 5000,
    // },
};

const tearCarousel = {
    slidesPerView: 1,
    // loop: true,
    autoplay: {
        delay: 4500,
    },
};

const locationCarousel = {
    freeMode: {
      enabled: true,
    //   minimumVelocity: 0.2,
    //   momentum: false,
    },
    spaceBetween: 4,
    mousewheel: {
        forceToAxis: true
    },
    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        hide: false
    }
};

const similarLocations = {
    loop: false,
};

export { _default, largeCarousel, locationCarousel, similarLocations, tearCarousel };
